<template lang="pug">
	.user-ai-settings(v-if="showed && user" v-window)
		.card(@click.stop)
			.card-header
				i.fa.fa-magic
				span User AI Settings
				.user-id User id: {{user.id}}
			.card-body.collapse.show
				.form-horizontal
					.form-group.budget.separator
						label {{user.name}}
						template(v-if="budget")
							.budget-line User AI budget: ${{budget['ai_budget'].toFixed(2)}}
							.budget-line Total spent on AI: ${{budget['ai_budget_spent'].toFixed(2)}}
						.description.text-muted(v-else)
							span Only the user and super admins can see the user AI budget
						.description.text-muted(v-if="publisher && !publisher['ai_budget_split']")
							span AI features of «{{publisher.title}}» are paid from the company AI budget. Users AI budgets are not used.
						//- Доступный текущему пользователю ИИ бюджет в открытом креативе (в порядке траты)
						.budget-line(v-if="user.id === User.currentUser.id && availableBudgetDescription") Available AI budget in the current creative: {{availableBudgetDescription}}
					.form-group.budget-transfer.separator(v-if="isPublisherAdmin && publisherBudget")
						label Company AI budget: ${{publisherBudget['ai_budget'].toFixed(2)}}
						template(v-if="publisherBudget['ai_budget_split']")
							.description.text-muted
								span Company admins can transfer the company AI budget to the user and back
							.form-line.budget
								InputSelect(:key="`transfer-amount-${transferInputKey}`" v-on:change="setTransferAmount($event)" :default="0" :value="transferAmount" :values="counts" :options="transferInputOptions" type="number" theme="dark-medium")
								button.btn.btn-primary.btn-sm(type="button" :disabled="!(transferAmount > 0) || transferAmount > publisherBudget['ai_budget']" @click="transferToUser()")
									i.fa.fa-arrow-right
									span Transfer to the user
								button.btn.btn-outline-primary.btn-sm(type="button" :disabled="!(transferAmount > 0)" @click="transferToPublisher()")
									i.fa.fa-arrow-left
									span Transfer to the company
						.description.text-muted(v-else)
							span Enable creatives and users AI budgets in the Company AI settings to transfer the company AI budget to users
					.form-group.budget-change.separator(v-if="isSuperAdmin")
						label Change user AI budget
						.description.text-muted
							span Super admins can add or remove AI budget from the user with a reason
						.form-line.budget
							InputSelect(:key="`budget-amount-${budgetInputKey}`" v-on:change="setBudgetAmount($event)" :default="0" :value="amount" :values="counts" :options="{dropdownWidth: 80}" type="number" theme="dark-medium")
							input.form-control.form-control-sm.reason(type="text" v-model="reason" placeholder="Reason" maxlength="300")
						.form-line.budget-buttons
							button.btn.btn-primary.btn-sm(type="button" :disabled="!canChangeBudget()" @click="addBudget()")
								i.fa.fa-plus
								span Add AI budget
							button.btn.btn-danger.btn-sm(type="button" :disabled="!canChangeBudget()" @click="removeBudget()")
								i.fa.fa-minus
								span Remove AI budget
					.form-group.budget-log.separator(v-if="budget")
						label AI budget changes
						.description.text-muted
							span When, who and why added, removed or transferred the user AI budget
						.budget-log-records(v-if="log.length" key="budget-log-records" v-bar :style="{height: `${Math.min(log.length, MAX_VISIBLE_LOG_RECORDS) * LOG_RECORD_HEIGHT}px`}")
							.budget-log-records-inner
								.budget-log-record(v-for="record in log" :key="record.id" :style="{height: `${LOG_RECORD_HEIGHT}px`}")
									.date {{formatDate(record.date)}}
									.amount(:class="{negative: record.amount < 0}") {{record.amount < 0 ? '-' : '+'}}${{Math.abs(record.amount).toFixed(2)}}
									.user {{record.userName || 'System'}}
									.reason(:title="record.reason") {{record.reason}}
						.empty-log(v-else key="empty-log") There are no AI budget changes yet
					.form-actions
						button.btn.btn-dark(type="button" @click="closeWindow()") Close
</template>

<script>

	import Screen 				from '../../mixins/screen'

	import { Creative } 			from '../../services/Creative'
	import { Publisher } 		from '../../services/Publisher'
	import { User } 			from '../../services/User'

	import InputSelect			from './../Editor/Controls/InputSelect'

	export default {
		name: "UserSettingsAI",
		mixins: [Screen],
		screen: {
			updateOn: [
				"User AI Budget Changed",
				"Publisher AI Budget Changed",
				"Creative AI Budget Changed",
				"Publishers Changed"
			],
			events: {
			}
		},
		components: {
			InputSelect
		},
		data() {

			this.Publisher = Publisher;
			this.User = User;

			// Сколько записей списка изменений бюджета видно без прокрутки и высота одной записи
			this.MAX_VISIBLE_LOG_RECORDS = 7;
			this.LOG_RECORD_HEIGHT = 32;

			this.log = [];

			this.counts = [
				{title: '$1', data: {itemValue: 1}},
				{title: '$5', data: {itemValue: 5}},
				{title: '$15', data: {itemValue: 15}},
				{title: '$50', data: {itemValue: 50}},
				{title: '$150', data: {itemValue: 150}}
			];

			// Сумма перевода, выбранная из меню, уменьшается до возможной (ручной ввод не изменяется)
			this.transferInputOptions = {
				dropdownWidth: 80,
				selectTransform: amount => this.limitTransferAmount(amount)
			};

			return {
				amount: 0,
				reason: '',
				transferAmount: 0,
				// Смена ключа пересоздаёт поле ввода суммы - так оно очищается (InputSelect хранит введённое значение у себя)
				transferInputKey: 0,
				budgetInputKey: 0
			}
		},
		methods: {
			// При открытии окна можно передать id пользователя (по умолчанию - текущий пользователь)
			collectData(eventName, userId) {

				if (eventName === 'show') this.userId = userId || User.currentUser.id;

				this.user = this.userId === User.currentUser.id ? User.currentUser : User.getUser(this.userId);

				if (!this.user) return;

				this.isSuperAdmin = !!User.currentUser.Tags['super-admin'];
				this.isPublisherAdmin = Publisher.isPublisherAdmin(this.user['publisher_id']);
				this.publisher = Publisher.getPublisher(this.user['publisher_id']);
				this.budget = User.AIBudgets[this.user.id];
				this.log = User.AIBudgetLogs[this.user.id] || [];
				this.publisherBudget = Publisher.AIBudgets[this.user['publisher_id']];
				this.availableBudgetDescription = Creative.getAvailableAIBudgetDescription(Creative.SelectedCreative);

				// ИИ бюджет пользователя (и бюджет паблишера для паблишер-админа) загружаем при открытии окна
				if (eventName === 'show') {

					Server.sendToServer({
						GetUserAI: {
							userId: this.user.id
						}
					});

				}

			},
			setTransferAmount(amount) {

				this.transferAmount = amount;

			},
			// Максимальная сумма перевода - больший из бюджетов паблишера и пользователя (перевод возможен в обе стороны), с округлением вниз до центов.
			// Бюджет пользователя видят только сам пользователь и супер-админы - если он неизвестен, максимум перевода паблишеру неизвестен и сумма не ограничивается
			limitTransferAmount(amount) {

				if (!this.budget) return amount;

				let maxAmount = Math.max(this.publisherBudget ? this.publisherBudget['ai_budget'] : 0, this.budget['ai_budget'], 0);

				return Math.min(amount, Math.floor(maxAmount * 100) / 100);

			},
			transferToUser() {

				Server.sendToServer({
					TransferPublisherAIBudgetToUser: {
						userId: this.user.id,
						amount: this.transferAmount
					}
				});

				this.clearTransferAmount();

			},
			transferToPublisher() {

				Server.sendToServer({
					TransferUserAIBudgetToPublisher: {
						userId: this.user.id,
						amount: this.transferAmount
					}
				});

				this.clearTransferAmount();

			},
			// После перевода бюджета очищаем поле суммы
			clearTransferAmount() {

				this.transferAmount = 0;
				this.transferInputKey++;

			},
			setBudgetAmount(amount) {

				this.amount = amount;

			},
			canChangeBudget() {

				return this.amount > 0 && this.reason.trim().length > 0;

			},
			addBudget() {

				Server.sendToServer({
					AddUserAIBudget: {
						userId: this.user.id,
						amount: this.amount,
						reason: this.reason.trim()
					}
				});

				this.clearBudgetChange();

			},
			removeBudget() {

				Server.sendToServer({
					RemoveUserAIBudget: {
						userId: this.user.id,
						amount: this.amount,
						reason: this.reason.trim()
					}
				});

				this.clearBudgetChange();

			},
			// После добавления / отнимания бюджета очищаем сумму и причину
			clearBudgetChange() {

				this.amount = 0;
				this.reason = '';
				this.budgetInputKey++;

			},
			formatDate(date) {

				return new Date(date).toLocaleString();

			}
		}
	}
</script>


<style lang="sass">

	.user-ai-settings
		display: flex
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)
		transition: opacity 0.2s

		.user-id
			position: absolute
			top: 19px
			right: 19px
			opacity: 0.1

		.separator
			padding-bottom: 20px
			border-bottom: 1px solid rgba(0, 0, 0, 0.3)
			margin-bottom: 10px

		.card
			width: 750px
			margin: auto
			display: flex
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)
			transition: 0.2s

			.btn-dark
				float: right
				color: #fff

		.form-line
			display: flex
			flex-direction: row
			align-items: center

		.form-group
			display: flex
			flex-direction: column

			> .description
				margin-bottom: 10px

			.budget-line
				margin-bottom: 5px

		.form-line.budget
			margin-bottom: 10px

			.input-select-control
				margin-right: 20px

				input
					width: 80px

			.reason
				width: 300px

			.btn-primary
				margin-right: 20px

		.form-line.budget-buttons

			.btn-primary
				margin-right: 20px

		.btn

			.fa
				margin-right: 7px

		.budget-log-records
			position: relative
			overflow: hidden

			.budget-log-records-inner

				&::-webkit-scrollbar
					width: 4px
				&::-webkit-scrollbar-thumb
					background-color: #3f454b
					border-radius: 10px
				&::-webkit-scrollbar-track
					background-color: #ADB6BF66

			.vb-dragger
				.vb-dragger-styler
					background-color: rgba(255, 255, 255, 0.2)

				&:hover .vb-dragger-styler
					background-color: rgba(255, 255, 255, 0.4)

			.budget-log-record
				display: flex
				flex-direction: row
				align-items: center
				white-space: nowrap

				.date
					width: 170px

				.amount
					width: 90px
					color: #4dbd74

					&.negative
						color: var(--red)

				.user
					width: 150px
					overflow: hidden
					text-overflow: ellipsis

				.reason
					flex: 1
					overflow: hidden
					text-overflow: ellipsis
					margin-right: 10px

		.form-actions
			margin-top: 20px

	.user-ai-settings.hiding
		opacity: 0

		.card
			transform: scale(0.9)

</style>
